module.exports = __webpack_public_path__ + "assets/img/addAddress.0148529a.png";